import { Typography } from "@repo/design-system";
import type {
  IRangeBound,
  RangeColumnsForFiltersForDTO,
} from "@/api/molecularData";
import { RANGE_FIELD_CONFIG, RANGE_FIELD_ORDER } from "@/lib/filterFieldConfig";
import type { RangeDraft } from "../../../hooks";
import { RangeFilterRow } from "./RangeFilterRow";

interface IRangeFiltersFieldsProps {
  rangeBounds: IRangeBound[];
  ranges: RangeDraft;
  onChange: (
    field: RangeColumnsForFiltersForDTO,
    next: { min: number; max: number } | undefined,
  ) => void;
}

export function RangeFiltersFields({
  rangeBounds,
  ranges,
  onChange,
}: IRangeFiltersFieldsProps) {
  if (rangeBounds.length === 0) {
    return (
      <Typography
        variant="paragraph-m-regular"
        className="text-contentTertiary">
        Range filters aren't available yet.
      </Typography>
    );
  }

  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
      {RANGE_FIELD_ORDER.map((field) => {
        const bound = rangeBounds.find((b) => b.field === field);
        if (!bound) return null;
        return (
          <RangeFilterRow
            key={field}
            field={field}
            config={RANGE_FIELD_CONFIG[field]}
            bound={bound}
            value={ranges[field]}
            onChange={onChange}
          />
        );
      })}
    </div>
  );
}
